export default __webpack_public_path__ + "static/media/90s_level_lost.fae3d3a2.mp3";